import React from 'react';
import { trustFacts } from '../../data/foundingProgram';
export function TrustSection() {
  return <section className="border-b border-[#D4AF37]/12 bg-[#0B0A0E]" data-id="element-1455" data-mp="21lj400rjbiwe">
      <div className="mx-auto w-full max-w-7xl px-5 py-20 sm:px-8" data-id="element-1456" data-mp="1wmpoy3wlnju4">
        <div className="grid gap-12 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20" data-id="element-1457" data-mp="1wkv38ndi7noz">
          <div data-id="element-1458" data-mp="1rmla0ibcax60">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1459" data-mp="1rn39rox7ntio">
              Credibility and trust
            </p>
            <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1460" data-mp="1ivkvxknqlpsr">
              Built by artists. Grounded in history.
            </h2>
            <div className="mt-10 border-l-2 border-[#D4AF37] pl-6" data-id="element-1461" data-mp="1du3xrwwn0hfv">
              <p className="font-serif text-2xl leading-snug text-[#FDFBF7]" data-id="element-1462" data-mp="18yg87ge8tm9u">
                In 2000, <span className="italic" data-id="element-1463" data-mp="13wz8vpbeq7vd">Arts of the Sikh Kingdoms</span>{' '}
                became the second most-attended exhibition in the history of the
                Royal Ontario Museum.
              </p>
            </div>
          </div>

          <div className="grid gap-px border border-[#D4AF37]/15 sm:grid-cols-2" data-id="element-1464" data-mp="3r6i8ueeo5obi">
            {trustFacts.map(fact => {
            const Icon = fact.icon;
            return <article key={fact.title} className="border-[#D4AF37]/15 p-7 [&:nth-child(-n+2)]:border-b [&:nth-child(odd)]:border-r" data-id="element-1465" data-mp="3hc8cymqiq7w1">
                  <Icon className="h-5 w-5 text-[#D4AF37]" aria-hidden="true" data-id="element-1466" data-mp="du812whudid5" />
                  <h3 className="mt-5 font-serif text-xl text-[#FDFBF7]" data-id="element-1467" data-mp="irqa0mvuzxl5">
                    {fact.title}
                  </h3>
                  <p className="mt-3 text-sm font-light leading-relaxed text-[#FDFBF7]/60" data-id="element-1468" data-mp="4sqkze4fpgog">
                    {fact.body}
                  </p>
                </article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}